import { useEffect } from 'react';
import { useWebSocket, ensureSocket } from './useWebSocket';
import { useChatInbound } from './useChatInbound';

/**
 * useChatCore - 对话系统核心连接器
 * 负责在应用全局或 Studio 布局挂载时，将底层 Socket 流量路由到下行消息处理器
 * @param enabled 是否开启连接（解决条件 Hook 问题）
 */
export const useChatCore = (enabled = true) => {
  const { onAgentMessage } = useWebSocket();
  const { handleInboundMessage } = useChatInbound();

  useEffect(() => {
    if (!enabled) return;

    // 确保 Socket 基础连接已建立
    ensureSocket();

    // 订阅全局 Agent 消息，并由独立业务 Hook 处理逻辑
    const cleanup = onAgentMessage((payload) => {
      handleInboundMessage(payload);
    });

    return () => {
      cleanup();
    };
  }, [enabled, onAgentMessage, handleInboundMessage]);
};
